// eslint-disable-next-line no-restricted-imports -- consistent with surrounding calendar code
import { addDays, eachDayOfInterval, startOfMonth, startOfWeek } from "date-fns";

export function getMonthlyCalendarDays(viewedMonth: Date): Date[] {
  const calendarStart = startOfWeek(startOfMonth(viewedMonth));
  const calendarEnd = addDays(calendarStart, 41);

  return eachDayOfInterval({ start: calendarStart, end: calendarEnd });
}

export function getMonthlyCalendarDateRange(viewedMonth: Date): { start: string; end: string } {
  const calendarDays = getMonthlyCalendarDays(viewedMonth);
  const start = calendarDays[0];
  const end = calendarDays[calendarDays.length - 1];

  return {
    start: start.toISOString(),
    end: end.toISOString(),
  };
}
